import { get, post } from '@partment/client'
import { IProfileMe } from '@partment/types'
import { v3Path } from './versionedPath'

export const getProfile = async (): Promise<IProfileMe> => {
  return get(v3Path('profiles/me/')) as unknown as Promise<IProfileMe>
}

export const profileLogout = async (
  token: string | undefined,
): Promise<any> => {
  return post(v3Path('accounts/auth/logout/'), {
    refresh: token,
  }) as unknown as Promise<any>
}
